import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip
);

export default function RevenueTrendLine() {
  const data = {
    labels: ["OCT", "NOV", "DEC", "JAN", "FEB"],
    datasets: [
      {
        label: "Revenue",
        data: [37.5, 50, 45, 60, 55],
        fill: false,
        borderColor: "#FBD150",
        backgroundColor: "#FBD150",
        tension: 0.4,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      y: {
        ticks: { display: false }, // hide Y-axis values
        grid: {
          drawTicks: false,
          color: "#1D2530", // dashed grid color
          borderDash: [4, 4], // make dashed lines
        },
        beginAtZero: true,
      },
      x: {
        grid: { drawTicks: false, color: "#1D2530", borderDash: [4, 4] },
      },
    },
  };

  return (
    <div className="bg-gradient-to-br from-[#0F131A] to-[#171D26] border border-[#1D2530] shadow-sm rounded-xl p-6 w-full mx-auto">
      {/* Header */}
      <div className="mb-4">
        <h3 className="text-[#F9FAFB] font-bold text-lg">Revenue Trend</h3>
        <p className="text-[#9DA6AF] text-sm mt-1">This month</p>
        <p className="text-[#F9FAFB] font-bold text-2xl mt-1">₹37.5K</p>
      </div>

      {/* Line Chart */}
      <div className="relative w-full h-64">
        <Line data={data} options={options} />
      </div>
    </div>
  );
}
